export const RESOURCE_CENTER_LABEL = 'Resource Center';
export const RESOURCE_CENTER_GET_STARTED_LABEL = 'Get started';
